import Settings from './settings';
import Overview from './overview';

export default {
  Settings,
  Overview,
};
